export class PWProductDto {
    id: number;
    productOrder: number;
    description: string;
    image: string;
    additionalInformation: string;
    customerAllegationId: string;
}